export default __webpack_public_path__ + "static/media/Montserrat-MediumItalic.5ff27e67.ttf";